module.exports = __webpack_public_path__ + "static/img/share_english.59b919b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share_english.png
// module id = kFo3
// module chunks = 2